import { Outlet } from "react-router-dom";
import CenterLoader from "./loader/CenterLoader";
import { useChatFeatures } from "@/shared/hooks/useChatFeatures";

export default function ChatFeatureLoader() {
  const { isLoading } = useChatFeatures();

  return isLoading ? <CenterLoader /> : <Outlet />;
}
